export const isAutobrokerCompatible = (option, auctionOption) => {
  const serviceTypes = auctionOption
    && auctionOption.auctionStrategyInfo
    && auctionOption.auctionStrategyInfo.serviceTypes;

  if (serviceTypes && Array.isArray(serviceTypes)) {
    if (option.id === 'premium+highlight') {
      return serviceTypes.includes('premium');
    }

    return serviceTypes.includes(option.id);
  }

  return false;
};

export const isAutobrokerEnabled = (auctionOption) =>
  Boolean(
    auctionOption &&
    auctionOption.auctionStrategyInfo &&
    auctionOption.auctionStrategyInfo.isEnabled
  );
